"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _dateFns = require("date-fns");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _Menu = _interopRequireDefault(require("../../Menu"));

var _Menu2 = require("../../Menu/Menu.styles");

var _SnoozeMenu = require("../../../containers/SnoozeMenu");

const Wrapper = _styledComponents.default.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;
const Label = _styledComponents.default.span`
  display: inline-flex;
  align-items: center;
  border: none;
  font-size: 14px;
  background: none;
`;

function showList({
  isOpen
}) {
  return isOpen ? 'block' : 'none';
}

const $List = (0, _styledComponents.default)(_Menu2.$Menu)`
  display: ${showList};
  left: auto;
  right: 0;
  top: 0;
  min-width: 240px;
`;
const Remaining = _styledComponents.default.span`
  display: inline-block;
  margin-top: 2px;
  font-weight: 400;
  text-transform: initial;
`;

function getSnoozedLength(endUnixTime) {
  return `${(0, _dateFns.formatDistanceToNowStrict)((0, _dateFns.fromUnixTime)(endUnixTime))} remaining`;
}

const RowAction = ({
  className,
  onMenuToggle,
  equipRuleId,
  isSnoozed,
  snoozeEnd
}) => /*#__PURE__*/_react.default.createElement(_Menu.default, {
  onToggle: onMenuToggle
}, ({
  isOpen,
  menuRef,
  toggle,
  close
}) => /*#__PURE__*/_react.default.createElement(Wrapper, {
  className: className,
  ref: menuRef,
  "data-cy": "RowSnooze"
}, /*#__PURE__*/_react.default.createElement(Label, {
  "data-cy": "RowSnooze-Icon"
}, isSnoozed ? /*#__PURE__*/_react.default.createElement(_blocks.IconButton, {
  onClick: toggle,
  icon: /*#__PURE__*/_react.default.createElement(_blocks.SnoozeTimeOutline, null)
}) : /*#__PURE__*/_react.default.createElement(_blocks.IconButton, {
  onClick: toggle,
  icon: /*#__PURE__*/_react.default.createElement(_blocks.SnoozeOutline, null)
})), /*#__PURE__*/_react.default.createElement($List, {
  isOpen: isOpen
}, !isSnoozed && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_blocks.ActionHeading, null, "Snooze"), /*#__PURE__*/_react.default.createElement(_SnoozeMenu.SnoozeMenu, {
  equipRuleIds: [equipRuleId],
  onClick: close
})), isSnoozed && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_blocks.ActionHeading, null, /*#__PURE__*/_react.default.createElement("span", null, "Snoozed"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(Remaining, null, getSnoozedLength(snoozeEnd))), /*#__PURE__*/_react.default.createElement(_SnoozeMenu.SnoozeMenu, {
  equipRuleIds: [equipRuleId],
  onClick: close,
  showUnsnooze: true,
  showSnooze: false
})))));

var _default = RowAction;
exports.default = _default;
module.exports = exports.default;